import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { RequiredLabel, InlineWarning, errorUtilities } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './email-element.style.js';
import { getCurrentValue } from '../text-input';

export class EmailElement extends Component {
  getValue() {
    const { response, defaultValue } = this.props;
    return getCurrentValue(response, defaultValue);
  }

  render() {
    const { isRequired, hidden, label, tooltip, id, onChange, response, disabled, readOnly, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');
    const inlineErrors = errors && errors.filter(err => err.type === errorUtilities.errorTypes.inline);

    if(hidden) return null;

    return (
      <div className={css.group + ' validated-section'}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          tooltip={tooltip}
          isRequired={isRequired}
          css={{
            requiredLabel: css.label,
            requiredIndicator: css.requiredIndicator}}/>
        <div className={css.inputWrapper}>
          <input
            id={id}
            type="email"
            value={this.getValue()}
            onChange={e => onChange(e.target.value)}
            className={css.input + ' validated-input'}
            disabled={disabled}
            readOnly={readOnly}
            aria-required={isRequired}
            aria-invalid={hasErrors && showErrors}
            aria-describedby={errorIds} />
            {inlineErrors && inlineErrors.map(warn => (
              <InlineWarning key={warn.id} warn={!!response ? warn.errorMessage : null}/>
            ))}
        </div>
      </div>
    );
  }
}

EmailElement.defaultProps = {
  isRequired: false
};

EmailElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  errors: PropTypes.object,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (EmailElement);



// WEBPACK FOOTER //
// src/common/form-elements/email-element-folder/email-element.js